import '../styles.scss'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from 'antd'

import { useAppSelector } from '@/store/hook'
import {
  selectEquipmentManagerLink,
  selectShouldRenderServiceMenu,
} from '@/store/selectors/configSelector'
import usePermission from '@/hooks/usePermission'
import { MODULE_SHOP_NAVIGATION_RIGHTS } from '@/libs/constants/modulerights'

import ServiceSubmenu from '../ServicesMenu'
import HeaderSubmenu from '../Submenu'

const HeaderMenu = () => {
  const { t } = useTranslation()
  const [showProductMenu, setShowProductMenu] = useState(false)
  const [showServiceMenu, setShowServiceMenu] = useState(false)

  const equipmentManagerLink = useAppSelector(selectEquipmentManagerLink)
  const shouldRenderServiceMenu = useAppSelector(selectShouldRenderServiceMenu)
  const { hasPermission: canViewCategoriesList } = usePermission(
    MODULE_SHOP_NAVIGATION_RIGHTS.USE_PRODUCT_NAVIGATION,
  )

  const items = [
    canViewCategoriesList && {
      key: 'product-navigation',
      label: (
        <button
          type="button"
          className={showProductMenu ? 'toggle-submenu-btn active' : 'toggle-submenu-btn'}
          onClick={() => {
              setShowProductMenu((previousValue) => !previousValue)
          }}
        >
          {t('product')}
        </button>
      ),
    },
    shouldRenderServiceMenu && {
      key: 'service-menu',
      label: (
        <button
          type="button"
          className={showServiceMenu ? 'toggle-submenu-btn active' : 'toggle-submenu-btn'}
          onClick={() => {
            setShowServiceMenu((previousValue) => !previousValue)
          }}
        >
          {t('services')}
        </button>
      ),
    },
    !!equipmentManagerLink && {
      key: 'equipment-manager',
      label: (
        <a
          className="toggle-submenu-btn"
          href={equipmentManagerLink}
          rel="noopener noreferrer"
          target="_blank"
          type="button"
        >
          {t('equipmentManagement')}
        </a>
      ),
    },
  ].filter(Boolean)

  return (
    <div className="menu-top-level__wrapper">
      <Menu
        disabledOverflow
        className="header-nav"
        items={items}
        mode="horizontal"
        style={{ minWidth: 0, flex: 'auto' }}
      />
      {showProductMenu && <HeaderSubmenu setShowSubmenu={setShowProductMenu} />}
      {showServiceMenu && <ServiceSubmenu setShowSubmenu={setShowServiceMenu} />}
    </div>
  )
}

export default HeaderMenu
